import axios, { AxiosResponse } from "axios";
import { MenuAccessApiResponse } from "../types/api/menuAccessApi";
import { MultiLanApiResponse } from "../types/api/multiLanguageApi";

const API_URL = process.env.REACT_APP_API_URL;


const customHeaders = {
    'Content-Type': 'application/json'
};

export const getMultiLanguageDataService = async (): Promise<AxiosResponse<MultiLanApiResponse>> => {
    try {
        const response = await axios.get(API_URL + 'multiple-language', { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        throw error;
    }
};